import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Divider,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Button as MuiButton,
} from "@mui/material";
import ArrowBackIosIcon from "src/Assets/images/Backword Icon.png";
import ArrowForwardIosIcon from "src/Assets/images/ForwordIcon.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LocationOnIcon from "src/Assets/images/locationpin.png";
import CloseIcon from "src/Assets/images/CloseButton.svg";
import { styled } from "@mui/material/styles";
import { CenteredElements } from "../Components/StyledComponents";
import Crown from "src/Assets/images/crown.svg";
import Send from "src/Assets/images/sendemail.svg";
import MapDialog from "../pages/HomePage/components/LocationAddress";
import Homepagesidebar from "../Modules/home/Homepagesidebar";
import API from "../network";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dot from "src/Assets/images/dot.png";
import TruncatedTextWithTooltip from "../Utils/truncatedTextWithTooltip";
import "./index.css";
import closeModalIcon from "src/Assets/images/Add.png";
import styles from "src/Assets/css/home/post.module.css";
import { useSelector } from "react-redux";
import AvatarBadge from "./AvatarBadge";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import feedstyles from "src/Assets/css/home/feedpost.module.css";

const Description = styled(Typography)({
  padding: "8px 15px 8px 15px",
  fontSize: "12px",
  wordBreak: "break-word",
});

const SubHeader = styled(Typography)({
  fontSize: "12px",
  marginBottom: "6px",
  color: "#707070",
  marginLeft: "30px",
});

const Name = styled(Typography)({
  fontSize: "12px",
});

const Container = styled("div")({
  position: "relative",
  width: "100%",
  height: "220px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#00000031",
  borderRadius: "20px",
  overflow: "hidden",
});

const TileSubHeader = styled(Typography)({
  fontSize: "11px",
  marginBottom: "6px",
  color: "#373334",
  marginLeft: "30px",
});

const goForward = {
  position: "absolute",
  top: "50%",
  right: "8px",
  transform: "translateY(-50%)",
  backgroundColor: "transparent",
  fontSize: "10px",
  outline: "none !important",
  border: "none !important",
  fontWeight: "1000",
};

const goBack = {
  position: "absolute",
  top: "50%",
  left: "8px",
  transform: "translateY(-50%)",
  backgroundColor: "transparent",
  fontSize: "10px",
  outline: "none !important",
  border: "none !important",
  fontWeight: "1000",
};

const closeIcon = {
  backgroundColor: "#F3F2F0 !important",
  fontSize: "10px",
  marginLeft: "auto !important",
  height: "28px",
  width: "28px",
  marginTop: "-10px !important",
  outline: "none !important",
};

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "50%",
//   height: "88%",
//   backgroundColor: "#ffffff",
//   borderRadius: "16px",
//   boxShadow: 24,
// };

const memberData = [
  {
    id: 1,
    image: "/images/1637236554131dev1832300035index.jpg",
    ask: 329,
    say: 344,
    update: 32,
    tag: 12,
    name: "Bruce Williams",
  },
];

const moderatorData = [
  {
    id: 1,
    image: "/images/1637236554131dev1832300035index.jpg",
    ask: 329,
    say: 344,
    update: 32,
    tag: 12,
    name: "Hanna Bartman",
  },
  {
    id: 2,
    image: "/images/1637236554131dev1832300035index.jpg",
    ask: 329,
    say: 344,
    update: 32,
    tag: 12,
    name: "Hanna Bartman",
  },
];

const PhotoPreview = (props) => {
  const {
    open,
    handleClose,
    tenantId,
    communityImage,
    communityDescription,
    communityName,
    tenantlatitude,
    tenantlongitude,
    communityAddress,
  } = props;
  const [currIndex, setCurrIndex] = useState(0);
  const [isFirstClick, setIsFirstClick] = useState(true); // Track if it's the first click
  const [photoTimeLineInitialData, setPhotoTimeLineData] = useState([]);
  const [moderatorData, setmoderatorData] = useState("");
  const [locationName, setLocationName] = useState("");
  const [thumbnailSelected, setThumbnailSelected] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const [blogText, setBlogText] = useState("");
  const [isLoadingBlog, setIsLoadingBlog] = useState(false);
  const [showBlogModal, setShowBlogModal] = useState(false);
  const [moderators, setModerators] = useState([]);
  const [isLoadingModerators, setIsLoadingModerators] = useState(false);
  const [impactfulMembers, setImpactfulMembers] = useState([]);
  const [isLoadingImpactfulMembers, setIsLoadingImpactfulMembers] =
    useState(false);
  console.log(props);
  useEffect(() => {
    setCurrIndex(0);
    setThumbnailSelected(false);
    API.getTimeLineImages(`tenantId=${tenantId}`)
      .then((res) => {
        setPhotoTimeLineData(res.data.imagesDetails);
      })
      .catch((err) => {});
  }, [tenantId]);

  // Load moderator blog for the selected community
  useEffect(() => {
    const getCommunityBlog = async () => {
      try {
        setIsLoadingBlog(true);
        setBlogText("");

        const response = await API.getCommunityBlog(tenantId);

        setBlogText(response?.data?.moderatorBlog || "");
      } catch (error) {
        console.error("Error fetching community blog:", error);
      } finally {
        setIsLoadingBlog(false);
      }
    };

    if (tenantId) {
      getCommunityBlog();
    }
  }, [tenantId]);

  useEffect(() => {
    const getImpactfulMembers = async () => {
      try {
        setIsLoadingImpactfulMembers(true);
        setImpactfulMembers([]);

        const response = await API.getAllImpactFUlMember(tenantId);

        const data = response?.data;

        if (data?.impactfulMembersList) {
          setImpactfulMembers(data.impactfulMembersList);
        } else {
          setImpactfulMembers([]);
        }
      } catch (error) {
        console.error("Error fetching impactful members:", error);
        setImpactfulMembers([]);
      } finally {
        setIsLoadingImpactfulMembers(false);
      }
    };

    if (tenantId) {
      getImpactfulMembers();
    }
  }, [tenantId]);

  useEffect(() => {
    const getModerators = async () => {
      try {
        setIsLoadingModerators(true);
        setModerators([]);

        const response = await API.getFollowingUsersByTenant({
          tenantId,
        });

        const data = response?.data;

        const moderatorUsers =
          data?.userList?.filter((user) => user?.isModerator == 1) || [];

        setModerators(moderatorUsers);
      } catch (error) {
        console.error("Error fetching moderators:", error);
        setModerators([]);
      } finally {
        setIsLoadingModerators(false);
      }
    };

    if (tenantId) {
      getModerators();
    }
  }, [tenantId]);

  const communityPhoto = {
    imageId: 1902,
    locName: communityAddress,
    locTagged: 0,
    tenantId: tenantId,
    timelineLogo: communityImage,
    tmlPhotoDesc: communityDescription,
    tmlPhotoLat: tenantlatitude,
    tmlPhotoLng: tenantlongitude,
  };

  const photoTimeLineData = photoTimeLineInitialData || [];
  const allPhotos = [communityPhoto, ...photoTimeLineData];
  console.log(`photoTimeLineData:`, photoTimeLineInitialData);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  const handleClickOpen = (address, lat, lng) => {
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const onCommunityLocationIconClick = () => {
    setClickedLocation({
      locAddress: communityAddress,
      latitude: tenantlatitude,
      longitude: tenantlongitude,
    });
    setOpenMap(true);
  };

  const handleCloseMap = () => {
    setOpenMap(false);
  };

  const handleForwardClick = () => {
    if (isFirstClick && currIndex === 0) {
      // First click: reset to index 0
      setCurrIndex(0);
      setLocationName(allPhotos[0]?.locName); // Set location for index 0
      setThumbnailSelected(true);
      setIsFirstClick(false); // Set to false after the first click
    } else {
      // Subsequent clicks: increment the index by 1
      const newIndex = currIndex + 1;
      if (newIndex < allPhotos.length) {
        setCurrIndex(newIndex);
        setLocationName(allPhotos[newIndex]?.locName); // Update location
        setThumbnailSelected(true);
        handleClickOpen(
          allPhotos[newIndex].locName,
          allPhotos[newIndex].tmlPhotoLat,
          allPhotos[newIndex].tmlPhotoLng,
        );
      }
    }
  };

  const handleLocationClick = (locName) => {
    setLocationName(locName);
    // console.log(locName);
  };
  const imageServerURL = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;

  // Truncate blog text for preview
  const truncatedBlogText =
    blogText.length > 150 ? `${blogText.slice(0, 150)}...` : blogText;

  return (
    <div>
      <Modal tenantId={tenantId} open={open} onClose={handleClose}>
        {allPhotos.length > 1 ? (
          <Box className="photoPreviewContainer">
            <Container>
              <div className="location-close-button-container">
                <IconButton
                  sx={closeIcon}
                  aria-label="close"
                  size="large"
                  onClick={() => {
                    handleClose();
                    setThumbnailSelected(false);
                    setCurrIndex(0);
                  }}
                >
                  <img src={CloseIcon} alt="crossIcon" className="cross-icon" />
                </IconButton>
              </div>
              <img
                src={
                  thumbnailSelected
                    ? `${imageServerURL}${allPhotos[currIndex].timelineLogo}`
                    : communityImage
                      ? `${imageServerURL}${communityImage}`
                      : process.env.REACT_APP_DUMMY_COMMUNITY_IMAGE // fallback: env community image
                }
                alt="CommunityImage"
                width="100%"
                height="220px"
                style={{
                  borderRadius: "20px",
                  marginBottom: "10px",
                  objectFit: "contain",
                }}
              />
              <div className="back-forward-container">
                <IconButton
                  sx={goBack}
                  aria-label="back"
                  size="small"
                  disabled={currIndex === 0}
                  onClick={() => {
                    const newIndex = currIndex - 1;
                    setCurrIndex(newIndex);
                    setLocationName(allPhotos[newIndex].locName);
                    setThumbnailSelected(true);
                    handleClickOpen(
                      allPhotos[newIndex].locName,
                      allPhotos[newIndex].tmlPhotoLat,
                      allPhotos[newIndex].tmlPhotoLng,
                    );
                  }}
                  className="icon-button"
                >
                  <img
                    src={ArrowBackIosIcon}
                    alt="backArrow"
                    className="icon-arrow"
                  />
                </IconButton>

                <IconButton
                  sx={goForward}
                  aria-label="forward"
                  size="small"
                  disabled={currIndex === allPhotos.length - 1}
                  onClick={handleForwardClick}
                  className="icon-button"
                >
                  <img
                    src={ArrowForwardIosIcon}
                    alt="forwardArrow"
                    className="icon-arrow"
                  />
                </IconButton>
              </div>
            </Container>
            <Description>
              {thumbnailSelected && currIndex > 0 ? (
                allPhotos[currIndex].tmlPhotoDesc ? (
                  <div className="community-description-text-and-location-container">
                    {/* <p className="community-description-text">
                      {allPhotos[currIndex].tmlPhotoDesc}
                    </p> */}
                    <TruncatedTextWithTooltip
                      text={allPhotos[currIndex].tmlPhotoDesc}
                      className="community-description-text"
                      lines={1}
                    />
                    {locationName.length > 0 && thumbnailSelected === true && (
                      <button
                        variant="outlined"
                        className="location-button"
                        onClick={() => setOpenMap(true)}
                      >
                        <div className="location-content">
                          <img
                            src={LocationOnIcon}
                            alt="location-icon"
                            className="location-icon"
                          />
                          <img src={dot} alt="dot" />
                          {/* <p className="location-text">{locationName}</p> */}
                          <TruncatedTextWithTooltip
                            text={locationName}
                            className="location-text"
                            lines={1}
                          />
                        </div>
                      </button>
                    )}
                  </div>
                ) : (
                  <p
                    style={{ color: "transparent", margin: "0px" }}
                    className="community-description-text"
                  >
                    {communityDescription}
                  </p>
                )
              ) : (
                <div>
                  <div className="community-name-location-container">
                    {/* <h6 className="community-name">{communityName}</h6> */}
                    <TruncatedTextWithTooltip
                      text={communityName}
                      className="community-name"
                      lines={1}
                    >
                      <h6>{communityName}</h6>
                    </TruncatedTextWithTooltip>
                    <img src={dot} alt="dot" />
                    <button
                      className="community-location-icon-button"
                      type="button"
                      onClick={onCommunityLocationIconClick}
                    >
                      <img
                        src={LocationOnIcon}
                        alt="location"
                        className="community-location-icon"
                      />
                    </button>
                  </div>
                  {/* <p className="community-description-text">
                    {communityDescription}
                  </p> */}
                  <TruncatedTextWithTooltip
                    text={communityDescription}
                    className="community-description-text"
                    lines={1}
                  />
                </div>
              )}
            </Description>

            <Divider style={{ margin: "15px 15px -3px 15px" }} />
            <div
              className="communityDetailsContainer"
              style={{
                padding: "8px 15px 8px 15px",
              }}
            >
              <div className="slider-container">
                <Slider {...settings} className="slider">
                  {allPhotos.map((item, i) => {
                    return (
                      <div
                        key={`key-imageId-${item.imageId}`}
                        className="photoContainer"
                        onClick={() => {
                          setCurrIndex(i);
                          setLocationName(item.locName);
                          setThumbnailSelected(true);
                          handleClickOpen(
                            item.locName,
                            item.tmlPhotoLat,
                            item.tmlPhotoLng,
                          );
                        }}
                      >
                        <img
                          src={`${imageServerURL}${item.timelineLogo}`}
                          alt={moderatorData.locName}
                          width="82px"
                          height="45px"
                          className={`slider-image ${
                            currIndex === i && (thumbnailSelected || i === 0)
                              ? "selected-image"
                              : ""
                          }`}
                        />
                      </div>
                    );
                  })}
                </Slider>
              </div>
              <SubHeader style={{ fontSize: "14px" }}>Community Blog</SubHeader>
              <div
                style={{
                  padding: "0 10px 2px 30px",
                }}
              >
                {isLoadingBlog ? (
                  <div style={{ marginTop: 5, fontSize: "10px" }}>
                    Loading...
                  </div>
                ) : blogText ? (
                  <div style={{ marginTop: 5 }}>
                    <div
                      style={{
                        fontSize: 13,
                        lineHeight: 1.6,
                        wordBreak: "break-word",
                      }}
                    >
                      {truncatedBlogText}
                      {blogText.length > 150 && (
                        <span
                          style={{
                            marginLeft: 4,
                            color: "#1976d2",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                          onClick={() => setShowBlogModal(true)}
                        >
                          See Full
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      marginTop: 5,
                      color: "#666",
                      fontSize: "10px",
                    }}
                  >
                    No community blog available.
                  </div>
                )}
              </div>
              <SubHeader style={{ fontSize: "14px", marginTop: "5px" }}>
                Impactful Member
              </SubHeader>
              {impactfulMembers?.length > 0 && (
                <div
                  style={{
                    paddingLeft: "30px",
                    marginTop: "8px",
                    paddingRight: "8px",
                  }}
                >
                  {impactfulMembers.map((member, index) => {
                    const user = member?.MainUserData;

                    return (
                      <div
                        key={user?.userid || index}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                          marginBottom: "12px",
                        }}
                      >
                        <AvatarBadge
                          src={`${imageServerURL}${user?.uimage}`}
                          className={styles.avatar}
                          isPrimaryModerator={
                            user?.isPM == 1 && user?.isModerator == 1
                          }
                          isModerator={
                            user?.isPM == 0 && user?.isModerator == 1
                          }
                        />

                        <div>
                          <span className={feedstyles.profilename}>
                            {user?.displayName}
                            {user?.isImpactableMember === "yes" && (
                              <img
                                src={alreadyImpactfulMemberImg}
                                alt="Impactful Member"
                                title="Impactful Member"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  objectFit: "contain",
                                  flexShrink: 0,
                                  marginLeft: "5px",
                                }}
                              />
                            )}
                          </span>

                          <div
                            style={{
                              fontSize: "11px",
                              color: "#666",
                              marginTop: "2px",
                              lineHeight: "18px",
                            }}
                          >
                            ASK {user?.askcount ?? 0} | SAY{" "}
                            {user?.saycount ?? 0}
                            {" | "}
                            UPDATE {user?.updatecount ?? 0}
                            {" | "}
                            TAG {user?.hashtagcount ?? 0}
                            {" | "}
                            Answers {user?.answercount ?? 0}
                            {" | "}
                            Replies {user?.replycount ?? 0}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              <SubHeader style={{ fontSize: "14px", marginTop: "5px" }}>
                Moderators
              </SubHeader>

              {moderators?.length > 0 && (
                <div
                  style={{
                    paddingLeft: "30px",
                    marginTop: "8px",
                    paddingRight: "8px",
                  }}
                >
                  {moderators.map((member, index) => {
                    const user = member?.userdataForCount;

                    return (
                      <div
                        key={`moderator-${user?.userid || member?.id || index}`}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                          marginBottom: "12px",
                        }}
                      >
                        <AvatarBadge
                          src={`${imageServerURL}${user?.uimage}`}
                          className={styles.avatar}
                          isPrimaryModerator={
                            user?.isPM == 1 && user?.isModerator == 1
                          }
                          isModerator={
                            user?.isPM == 0 && user?.isModerator == 1
                          }
                        />

                        <div>
                          <span className={feedstyles.profilename}>
                            {user?.displayName}
                          </span>

                          <div
                            style={{
                              fontSize: "11px",
                              color: "#666",
                              marginTop: "2px",
                              lineHeight: "18px",
                            }}
                          >
                            ASK {user?.askcount ?? 0} | SAY{" "}
                            {user?.saycount ?? 0}
                            {" | "}
                            UPDATE {user?.updatecount ?? 0}
                            {" | "}
                            TAG {user?.hashtagcount ?? 0}
                            {" | "}
                            Answers {user?.answercount ?? 0}
                            {" | "}
                            Replies {user?.replycount ?? 0}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Box>
        ) : (
          <Box className="photoPreviewContainer">
            <Container>
              <img
                src={`${imageServerURL}${communityImage}`}
                alt="Community Image"
                width="100%"
                height="220px"
                style={{ borderRadius: "16px" }}
              />
              <div className="location-close-button-container">
                <span></span>
                <IconButton
                  sx={closeIcon}
                  aria-label="close"
                  size="small"
                  onClick={handleClose}
                >
                  <img
                    src={CloseIcon}
                    alt="crossIcon"
                    style={{ height: "15px" }}
                  />
                </IconButton>
              </div>
            </Container>
            <Description>
              <div>
                <div className="community-name-location-container">
                  <TruncatedTextWithTooltip
                    text={communityName}
                    className="community-name"
                    lines={1}
                  >
                    <h6>{communityName}</h6>
                  </TruncatedTextWithTooltip>
                  <img src={dot} alt="dot" style={{ marginTop: "-5px" }} />
                  <button
                    className="community-location-icon-button"
                    type="button"
                    onClick={onCommunityLocationIconClick}
                    style={{ marginTop: "-5px" }}
                  >
                    <img
                      src={LocationOnIcon}
                      alt="location"
                      className="community-location-icon"
                    />
                  </button>
                </div>
                {/* <p className="community-description-text">
                  {communityDescription}
                </p> */}
                <TruncatedTextWithTooltip
                  text={communityDescription}
                  className="community-description-text"
                  lines={1}
                />
              </div>
            </Description>
            <Divider
              style={{
                marginLeft: "15px",
                marginRight: "15px",
                marginBottom: "0px",
                marginTop: "5px",
              }}
            />
            <div
              className="communityDetailsContainer"
              style={{
                padding: "8px 15px 8px 15px",
                overflow: "auto",
                height: "230px",
              }}
            >
              <SubHeader>Community Blog</SubHeader>
              <div
                style={{
                  padding: "0 10px 2px 30px",
                }}
              >
                {isLoadingBlog ? (
                  <div style={{ marginTop: 5, fontSize: "10px" }}>
                    Loading...
                  </div>
                ) : blogText ? (
                  <div style={{ marginTop: 5 }}>
                    <div
                      style={{
                        fontSize: 13,
                        lineHeight: 1.6,
                        wordBreak: "break-word",
                      }}
                    >
                      {truncatedBlogText}
                      {blogText.length > 150 && (
                        <span
                          style={{
                            marginLeft: 4,
                            color: "#1976d2",
                            cursor: "pointer",
                            fontWeight: 500,
                          }}
                          onClick={() => setShowBlogModal(true)}
                        >
                          See Full
                        </span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      marginTop: 5,
                      color: "#666",
                      fontSize: "10px",
                    }}
                  >
                    No community blog available.
                  </div>
                )}
              </div>
              <SubHeader style={{ fontSize: "14px", marginTop: "5px" }}>
                Impactful Member
              </SubHeader>
              {impactfulMembers?.length > 0 && (
                <div
                  style={{
                    paddingLeft: "30px",
                    marginTop: "8px",
                    paddingRight: "8px",
                  }}
                >
                  {impactfulMembers.map((member, index) => {
                    const user = member?.MainUserData;

                    return (
                      <div
                        key={user?.userid || index}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                          marginBottom: "12px",
                        }}
                      >
                        <AvatarBadge
                          src={`${imageServerURL}${user?.uimage}`}
                          className={styles.avatar}
                          isPrimaryModerator={
                            user?.isPM == 1 && user?.isModerator == 1
                          }
                          isModerator={
                            user?.isPM == 0 && user?.isModerator == 1
                          }
                        />

                        <div>
                          <span className={feedstyles.profilename}>
                            {user?.displayName}
                            {user?.isImpactableMember === "yes" && (
                              <img
                                src={alreadyImpactfulMemberImg}
                                alt="Impactful Member"
                                title="Impactful Member"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  objectFit: "contain",
                                  flexShrink: 0,
                                  marginLeft: "5px",
                                }}
                              />
                            )}
                          </span>

                          <div
                            style={{
                              fontSize: "11px",
                              color: "#666",
                              marginTop: "2px",
                              lineHeight: "18px",
                            }}
                          >
                            ASK {user?.askcount ?? 0} | SAY{" "}
                            {user?.saycount ?? 0}
                            {" | "}
                            UPDATE {user?.updatecount ?? 0}
                            {" | "}
                            TAG {user?.hashtagcount ?? 0}
                            {" | "}
                            Answers {user?.answercount ?? 0}
                            {" | "}
                            Replies {user?.replycount ?? 0}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              <SubHeader style={{ fontSize: "14px", marginTop: "5px" }}>
                Moderators
              </SubHeader>

              {moderators?.length > 0 && (
                <div
                  style={{
                    paddingLeft: "30px",
                    marginTop: "8px",
                    paddingRight: "8px",
                  }}
                >
                  {moderators.map((member, index) => {
                    const user = member?.userdataForCount;

                    return (
                      <div
                        key={`moderator-${user?.userid || member?.id || index}`}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "10px",
                          marginBottom: "12px",
                        }}
                      >
                        <AvatarBadge
                          src={`${imageServerURL}${user?.uimage}`}
                          className={styles.avatar}
                          isPrimaryModerator={
                            user?.isPM == 1 && user?.isModerator == 1
                          }
                          isModerator={
                            user?.isPM == 0 && user?.isModerator == 1
                          }
                        />

                        <div>
                          <span className={feedstyles.profilename}>
                            {user?.displayName}
                          </span>

                          <div
                            style={{
                              fontSize: "11px",
                              color: "#666",
                              marginTop: "2px",
                              lineHeight: "18px",
                            }}
                          >
                            ASK {user?.askcount ?? 0} | SAY{" "}
                            {user?.saycount ?? 0}
                            {" | "}
                            UPDATE {user?.updatecount ?? 0}
                            {" | "}
                            TAG {user?.hashtagcount ?? 0}
                            {" | "}
                            Answers {user?.answercount ?? 0}
                            {" | "}
                            Replies {user?.replycount ?? 0}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Box>
        )}
      </Modal>
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
        displayType={"photoPreview"}
      />
      <Modal open={showBlogModal} onClose={() => setShowBlogModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            borderRadius: "12px",
            padding: "20px",
            width: "90%",
            maxWidth: "600px",
            maxHeight: "80vh",
            overflowY: "auto",
            outline: "none",
          }}
        >
          {/* Modal Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <h5 style={{ margin: 0, fontWeight: 500 }}>Community Blog</h5>

            <img
              src={closeModalIcon}
              alt="Close"
              onClick={() => setShowBlogModal(false)}
              style={{
                width: 18,
                height: 18,
                cursor: "pointer",
              }}
            />
          </div>

          {/* Blog Content */}
          <div
            style={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.7,
              wordBreak: "break-word",
            }}
          >
            {blogText}
          </div>
        </Box>
      </Modal>
    </div>
  );
};

const Tile = (props) => {
  const { data } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!Array.isArray(data)) {
    return <div>No moderator data available.</div>;
  }
  const imageServerURL = process.env.REACT_APP_SKOPIC_IMAGE_OTHER;
  return (
    <>
      {data.map((item) => (
        <div style={{ display: "flex" }} key={item.id}>
          <div style={{ position: "relative", marginRight: "10px" }}>
            <Avatar src={`${imageServerURL}${item.image}`} />
            <img
              src={Crown}
              alt="Crown"
              style={{ position: "absolute", bottom: "0px", right: "0px" }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Name>{item.name}</Name>
            <TileSubHeader>
              ASK {item.ask} | SAY {item.say} | UPDATE {item.update} | TAG{" "}
              {item.tag}
            </TileSubHeader>
          </div>
          <IconButton onClick={handleClick} size="small">
            <KeyboardArrowDownIcon />
          </IconButton>
          <Menu
            id="basic-menu"
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={() => {}}>
              <img src={Send} alt="send" style={{ marginRight: "6px" }} /> Send
              email to {item.name}
            </MenuItem>
          </Menu>
        </div>
      ))}
    </>
  );
};

export default PhotoPreview;
